import request from './request';
// 获取微信用户信息
export function wx_Auth(params = {}) {
    return request({
      url: '/wx/auth',
      method: 'get',
      params: params
    })
}
//查询卡
export function wx_validate(params = {}) {
    return request({
      url: '/wx/card/validate',
      method: 'get',
      params: params
    })
}
//初始话查询卡
export function wx_initCard(params = {}) {
  return request({
    url: '/wx/card/initCard',
    method: 'get',
    params: params
  })
}
export function wx_mxGetDetail(params = {}) {
  return request({
    url: '/wx/card/getDetail',
    method: 'get',
    params: params
  })
}
export function wx_mxGetProducts(params = {}) {
  return request({
    url: '/wx/card/getProducts',
    method: 'get',
    params: params
  })
}
// 清空卡
export function wx_clear(params = {}) {
    return request({
      url: '/wx/card/clear',
      method: 'get',
      params: params
    })
}
// 获取微信记录
export function wx_record(params = {}) {
    return request({
      url: '/wx/card/record',
      method: 'get',
      params: params
    })
}
// 查询卡详情
export function wx_card(params = {}) {
    return request({
      url: '/wx/card',
      method: 'get',
      params: params
    })
}
// 保存人联网预实名记录
export function wx_rlwSavePreCertRecord(params = {}) {
    return request({
        url: '/wx/card/rlwSavePreCertRecord',
        method: 'post',
        data: params
    })
}
// 提示实名
export function wx_card_tipCert(params = {}) {
    return request({
        url: '/wx/card/tipCert',
        method: 'get',
        params: params
    })
}
// 获取实名url
export function wx_getRealNameUrl(params = {}) {
    return request({
        url: '/wx/card/getRealNameUrl',
        method: 'get',
        params: params
    })
}

// 查询卡剩余流量
export function wx_flow(params = {}) {
    return request({
      url: '/wx/card/flow',
      method: 'get',
      params: params
    })
}

// 微信绑定手机号
export function wx_bindPhone(params = {}) {
    return request({
      url: '/wx/card/bindPhone',
      method: 'post',
      data: params
    })
}
// 获取卡订购的套餐
export function wx_product(params = {}) {
    return request({
      url: '/wx/card/product',
      method: 'post',
      data: params
    })
}
// 刷新卡
export function wx_refresh(params = {}) {
    return request({
      url: '/wx/card/refresh',
      method: 'get',
      params: params
    })
}
// 获取套餐
export function wx_getproduct(params = {}) {
    return request({
      url: '/wx/card/product',
      method: 'get',
      params: params
    })
}
// 获取套餐详情
export function wx_productDetail(params = {}) {
    return request({
      url: '/wx/card/productDetail',
      method: 'get',
      params: params
    })
}
// 微信下单
export function wx_pay(params = {}) {
    return request({
      url: '/wx/web/pay/order',
      method: 'post',
      data: params
    })
}

// 免显微信下单
export function wx_noShowPay(params = {}) {
  return request({
    url: '/wx/web/pay/noShowPay',
    method: 'post',
    data: params
  })
}
//支付结果查询
export function wx_payResult(params = {}) {
  return request({
    url: '/wx/web/pay/payResult',
    method: 'get',
    params: params
  })
}

// 微信下单的验证码
export function wx_sendOrderSms(params = {}) {
    return request({
      url: '/sms/sendOrderSms',
      method: 'get',
      params: params
    })
}
// h5下单生成未支付的订单号前校验手机号与验证码
export function wx_preOrder_check(params = {}) {
    return request({
        url: '/wx/web/pay/preOrderCheck',
        method: 'post',
        data: params
    })
}
// h5根据订单号去支付
export function wx_payOrder(params = {}) {
    return request({
      url: '/wx/web/pay/payOrder',
      method: 'post',
      data: params
    })
}
// 解除支付宝自动续费的详情
export function wx_agreementInfo(params = {}) {
    return request({
      url: '/wx/card/agreementInfo',
      method: 'get',
      params: params
    })
}
// 解除支付宝自动续费时的验证码
export function wx_sendRelieveSms(params = {}) {
    return request({
      url: '/sms/sendRelieveSms',
      method: 'get',
      params: params
    })
}
// 解除支付宝自动续费
export function wx_relieveAgreement(params = {}) {
    return request({
      url: '/wx/card/relieveAgreement',
      method: 'post',
      data: params
    })
}
// 查询订单的支付状态
export function wx_queryOrder(params = {}) {
    return request({
      url: '/wx/web/pay/queryOrder',
      method: 'get',
      params: params
    })
}

// 获取个人中心页面的积分与默认iccid
export function wx_total(params = {}) {
    return request({
      url: '/wx/card/integral/total',
      method: 'get',
      params: params
    })
}
// 个人中心获取订单
export function wx_order(params = {}) {
    return request({
      url: '/wx/card/order',
      method: 'get',
      params: params
    })
}
// 个人中心获取积分
export function wx_integral(params = {}) {
    return request({
      url: '/wx/card/integral',
      method: 'get',
      params: params
    })
}
// 实名发送短信
export function wx_sendCertSms(params = {}) {
    return request({
      url: '/sms/sendCertSms',
      method: 'get',
      params: params
    })
}
// 验证短信
export function wx_verifyCertCode(params = {}) {
    return request({
      url: '/sms/verifyCertCode',
      method: 'get',
      params: params
    })
}
// 提交实名信息
export function wx_saveCertRecord(params = {}) {
    return request({
      url: '/cardCert/saveCertRecord',
      method: 'post',
      data: params
    })
}
//获取补卡的省市区
export function wx_area(params = {}) {
    return request({
      url: '/wx/card/area',
      method: 'get',
      params: params
    })
}
// 补卡套餐信息提交
export function changeCard(params = {}) {
    return request({
      url: '/wx/card/changeCard',
      method: 'post',
      data: params
    })
}
// 补卡信息详情
export function changeCardInfo(params = {}) {
  return request({
    url: '/wx/card/changeCardInfo',
    method: 'get',
    params: params
  })
}
// 新用户领取套餐的详情
export function wx_getReceiveProductDetail(params = {}) {
    return request({
      url: '/wx/card/getReceiveProductDetail',
      method: 'get',
      params: params
    })
}
// 新用户发送领取流量短信
export function wx_sendReceiveSms(params = {}) {
    return request({
      url: '/sms/sendReceiveSms',
      method: 'get',
      params: params
    })
}
// 新用户领取流量
export function wx_receiveProduct(params = {}) {
    return request({
      url: '/wx/card/receiveProduct',
      method: 'post',
      data: params
    })
}

// 畅想套餐的使用详情
export function wx_cardProductDetail(params = {}) {
    return request({
      url: '/wx/card/cardProductDetail',
      method: 'get',
      params: params
    })
}
// 畅想套餐叠加包的使用详情
export function wx_speedProductUsed(params = {}) {
    return request({
      url: '/wx/card/speedProductUsed',
      method: 'get',
      params: params
    })
}
// 畅想充值加速包套餐列表
export function wx_speedProduct(params = {}) {
    return request({
      url: '/wx/card/speedProduct',
      method: 'get',
      params: params
    })
}
// 查询可开发票订单
export function wx_invoiceList(params = {}) {
    return request({
      url: '/wx/invoice/list',
      method: 'get',
      params: params
    })
}
// 验证码
export function wx_invoiceSendInvoiceSms(params = {}) {
    return request({
      url: '/sms/sendInvoiceSms',
      method: 'get',
      params: params
    })
}
// 获取已保存的公司开票信息
export function wx_invoiceUserInvoiceCompany(params = {}) {
    return request({
      url: '/wx/invoice/userInvoiceCompany',
      method: 'get',
      params: params
    })
}
// 验证申请开票的手机
export function wx_invoiceCheckPhone(params = {}) {
    return request({
      url: '/wx/invoice/checkPhone',
        method: 'post',
        data: params
    })
}
// 保存开票公司信息
export function wx_invoiceSaveInvoiceCompany(params = {}) {
    return request({
      url: '/wx/invoice/saveInvoiceCompany',
      method: 'post',
      data: params
    })
}
// 普通发票详情信息提交
export function wx_invoiceSaveInvoiceDetail(params = {}) {
    return request({
      url: '/wx/invoice/saveInvoiceDetail',
      method: 'post',
      data: params
    })
}
// 专用发票详情信息提交
export function wx_specialInvoiceSaveInvoiceDetail(params = {}) {
    return request({
      url: '/wx/invoice/saveSpecialInvoiceDetail',
      method: 'post',
      data: params
    })
}
// 个人中心获取验证码
export function wx_sendWxUserSms(params = {}) {
    return request({
      url: '/sms/sendWxUserSms',
      method: 'get',
      params: params
    })
}

//手机号验证是否注册
export function wx_userPhone(params = {}) {
    return request({
      url: '/wx/center/userPhone',
      method: 'get',
      params: params
    })
}
// 个人中心登陆-token
export function wx_userLogin(params = {}) {
    return request({
      url: '/wx/center/userLogin',
      method: 'post',
      data: params
    })
}
// 个人中心获取数据
export function wx_userInfo(params = {}) {
    return request({
      url: '/wx/center/userInfo',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心提交卡批量充值
export function wx_userProduct(params = {}) {
    return request({
      url: '/wx/center/product',
      method: 'post',
      headers: {
        isToken: true
      },
      data: params
    })
}
// 个人中心绑定卡
export function wx_bindCard(params = {}) {
    return request({
      url: '/wx/center/bindCard',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心获取初始化卡数据
export function wx_bindCardInfo(params = {}) {
    return request({
      url: '/wx/center/bindCardInfo',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心解绑卡
export function wx_unBindCard(params = {}) {
    return request({
      url: '/wx/center/unBindCard',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心获取套餐详情
export function wx_center_productDetail(params = {}) {
    return request({
      url: '/wx/center/productDetail',
      method: 'post',
      headers: {
        isToken: true
      },
      data: params
    })
}
// 个人中心微信下单
export function wx_batchOrderr(params = {}) {
    return request({
      url: '/wx/center/batchOrder',
      method: 'post',
      headers: {
        isToken: true
      },
      data: params
    })
}
// 个人中心获取积分的信息
export function wx_userBindCardList(params = {}) {
    return request({
      url: '/wx/center/userBindCardList',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心获取积分兑换的卡以及套餐
export function wx_integralExchangeList(params = {}) {
    return request({
      url: '/wx/center/integralExchangeList',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心积分兑换套餐
export function wx_integralExchange(params = {}) {
    return request({
      url: '/wx/center/integralExchange',
      method: 'post',
      headers: {
        isToken: true
      },
      data: params
    })
}
// 个人中心获取我的订单
export function wx_userOrderList(params = {}) {
    return request({
      url: '/wx/center/userOrderList',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心获取发票记录
export function wx_userInvoiceList(params = {}) {
    return request({
      url: '/wx/center/userInvoiceList',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 卡详情获取二维码的链接
export function wx_card_qrcode(params = {}) {
    return request({
      url: 'wx/card/qrcode',
      method: 'get',
      params: params
    })
}
// 个人中心获取账户积分明细
export function wx_userIntegralDetailList(params = {}) {
    return request({
      url: '/wx/center/userIntegralDetailList',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 个人中心获取卡积分明细
export function wx_cardIntegralDetailList(params = {}) {
    return request({
      url: '/wx/center/cardIntegralDetailList',
      method: 'get',
      headers: {
        isToken: true
      },
      params: params
    })
}
// 国际流量获取国家位置
export function getCountry(params = {}) {
    return request({
        url: 'international/country',
        method: 'get',
        params: params
    })
}
// 国际流量卡详情
export function wx_international(params = {}) {
    return request({
      url: '/international',
      method: 'get',
      params: params
    })
}
// 国际流量卡查询卡流量
export function wx_internationalFlow(params = {}) {
    return request({
      url: '/international/flow',
      method: 'get',
      params: params
    })
}
// 国际流量卡获取状态数据
export function wx_internationalProduct(params = {}) {
    return request({
      url: '/international/product',
      method: 'post',
      data: params
    })
}
// 国际流量卡获取可以充值的套餐
export function wx_internationalProductList(params = {}) {
    return request({
      url: '/international/productList',
      method: 'get',
      params: params
    })
}
// 国际流量卡获取套餐信息
export function wx_internationalProductInfo(params = {}) {
    return request({
        url: '/international/productInfo',
        method: 'get',
        params: params
    })
}
// 国际流量卡获取订单列表
export function wx_internationalOrderList(params = {}) {
    return request({
        url: '/international/orderList',
        method: 'post',
        data: params
    })
}
// 国际流量卡充值
export function wx_paypalPay(params = {}) {
    return request({
      url: '/paypal/pay',
      method: 'post',
      data: params
    })
}
// 国际流量的支付后的信息
export function wx_paypalSuccess(params = {}) {
    return request({
      url: 'paypal/success',
      method: 'get',
      params: params
    })
}

// 所有支持的运营商国家
export function wx_internationalCountryList(params = {}) {
  return request({
      url: '/international/countryList',
      method: 'get',
      params: params
  })
}
// 卡短信记录查询
export function wxCardSmsRecord(params = {}) {
    return request({
      url: '/wx/sms/record',
      method: 'get',
      params: params
    })
}

// 卡短信发送
export function wxCardSmsSend(params = {}) {
    return request({
      url: '/wx/sms/send',
      method: 'post',
      data: params
    })
}

// 卡短信充值
export function wxPaySms(params = {}) {
    return request({
      url: '/wx/web/pay/smsPay',
      method: 'post',
      data: params
    })
}







































